import { render } from "./Footer_m.vue?vue&type=template&id=16624420&scoped=true"
import script from "./Footer_m.vue?vue&type=script&lang=js"
export * from "./Footer_m.vue?vue&type=script&lang=js"

import "./Footer_m.vue?vue&type=style&index=0&id=16624420&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16624420"

export default script